import Icon from '@ant-design/icons';
import type { ComponentProps } from 'react';

/** Core Icon Library — icon/check (Third Eye style card, 24px grid, solid fill). */
const CheckSvg = () => (
  <svg viewBox='0 0 24 24' width='1em' height='1em' fill='none' aria-hidden='true'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M19.916 4.626C20.0815 4.73634 20.1964 4.9079 20.2354 5.10293C20.2744 5.29796 20.2343 5.50051 20.124 5.666L11.124 19.166C11.0624 19.2582 10.9812 19.3357 10.8861 19.3927C10.7909 19.4498 10.6844 19.485 10.574 19.4959C10.4636 19.5068 10.3522 19.4931 10.2478 19.4558C10.1433 19.4185 10.0485 19.3584 9.97003 19.28L3.97003 13.28C3.83755 13.1378 3.76543 12.9498 3.76885 12.7555C3.77228 12.5612 3.85099 12.3758 3.98841 12.2384C4.12582 12.101 4.31121 12.0223 4.50551 12.0188C4.69981 12.0154 4.88785 12.0875 5.03003 12.22L10.383 17.573L18.876 4.833C18.9865 4.66768 19.1581 4.553 19.3532 4.51419C19.5482 4.47537 19.7507 4.51559 19.916 4.626Z'
      fill='currentColor'
    />
  </svg>
);

export const CheckIcon = (props: Partial<ComponentProps<typeof Icon>>) => (
  <Icon aria-label='check' component={CheckSvg} {...props} />
);
